<nav [class]="styles.container()">
  <ul [class]="styles.items()">
    @for (item of filteredMenuItems(); track item.route) {
      <li [class]="styles.item()">
        <a [routerLink]="item.route" [class]="getLinkClassesForItem(item).link()">
          <edu-icon [icon]="item.icon" [iconClasses]="getLinkClassesForItem(item).icon()" />
          <span [class]="getLinkClassesForItem(item).label()">{{ item.label | transloco }}</span>
        </a>
      </li>
    }
  </ul>
</nav>
